import isEmpty from 'lodash/isEmpty';

import { Member } from '../../types/Member';
import { Party } from '../../types/Party';

import { getIdeasList } from './parties';

export function mapFromIdeaToTemplate(idea) {
  return {
    title: idea.title,
    src: idea.url,
  };
}

export function getMembers(party: Party): Member[] {
  if (!party || !party.members) return [];
  return party.members;
}

export function mapFromActivityToTemplate(activity) {
  return {
    title: activity.title,
    src: activity.pictures[0]?.url,
  };
}

export function mapFromAttendeesToOrderBookingOptions(
  attendees,
  selectedBookingOptions,
  partyPlannerMember
) {
  return selectedBookingOptions.map(selectedOption => {
    if (selectedOption.pricingModel === 'party') {
      return {
        id: selectedOption.id,
        attendees: partyPlannerMember
          ? [
              {
                id: partyPlannerMember.memberId,
                name: partyPlannerMember.memberName,
              },
            ]
          : [{}],
      };
    }
    return {
      id: selectedOption.id,
      attendees: attendees.map(attendee => {
        if (isEmpty(attendee)) {
          return {};
        }
        return {
          id: attendee.memberId,
          name: attendee.memberName,
        };
      }),
    };
  });
}

export function getEventOrder(profile, order, event) {
  let eventOrders = [];
  const eventOrder = {
    memberId: profile.id,
    orderId: order.id,
  };
  if (event && event.orders && event.orders.length > 0) {
    eventOrders = event.orders;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    eventOrders.push(eventOrder);
  } else {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    eventOrders.push(eventOrder);
  }
  return eventOrders;
}

export function getCreatedFrom(event, activity, party) {
  if (activity) {
    return activity.bookable ? 'Bookable' : 'Non-bookable';
  }
  const ideas = getIdeasList(party);
  const isIdea =
    ideas.filter(
      idea =>
        idea.category === event.eventCategory && idea.title === event.eventTitle
    ).length > 0;
  return isIdea ? 'Idea' : 'Custom';
}
